import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Flex, Box } from 'rebass';
import ReactGA from 'react-ga';
import styled from 'styled-components';
import log from 'loglevel';

import ContentWrapper from 'Components/ContentWrapper';

import UniversityList from '../UniversityList';
import FacultyList from '../FacultyList';

import { NavBar, NavHeader, Steps, renderHeader } from './BUComponents';

const NoTopWrapper = styled(ContentWrapper)`
  padding-top: 0;
  min-width: auto;
`;

const generateSteps = (browseHistory = []) => browseHistory.map(history => history.browseText);

const BROWSE_STATE = {
  BROWSE_UNIVERSITY: 0,
  BROWSE_FACULTY: 1,
  BROWSE_UNIVERSITY_BY_EDUTAG: 10,
  BROWSE_FACULTY_BY_EDUTAG: 11,
  BROWSE_DEPARTMENT_BY_FACULTY_EDUTAG: 12,
  BROWSE_DEPARTMENT_BY_EDUTAG: 13,
};

const BROWSE_END_STATE = {
  [BROWSE_STATE.BROWSE_FACULTY]: true, // Leave this until we dig more
};

const BROWSE_STATE_TEXT = {
  [BROWSE_STATE.BROWSE_UNIVERSITY]: 'เลือกมหาวิทยาลัย',
  [BROWSE_STATE.BROWSE_FACULTY]: 'เลือกคณะ',
};

const getStepsIndex = currentState => {
  switch (currentState) {
    case BROWSE_STATE.BROWSE_UNIVERSITY:
      return { current: 0, total: 2 };
    case BROWSE_STATE.BROWSE_FACULTY:
      return { current: 1, total: 2 };
    default:
      return {};
  }
};

const getNextState = (currentState, currentValue, id, data) => {
  // console.log(currentState, id, data);
  switch (currentState) {
    case BROWSE_STATE.BROWSE_UNIVERSITY:
      return {
        browseState: BROWSE_STATE.BROWSE_FACULTY,
        browseValue: id,
        browseText: data.title,
      };

    case BROWSE_STATE.BROWSE_FACULTY:
      return {
        browseValue: id,
        browseText: data.title,
      };

    default:
      return {};
  }
};

export default class BrowseUniversity extends Component {
  state = {
    browseState: BROWSE_STATE.BROWSE_UNIVERSITY,
    browseHistory: [],
    browseValue: null,
    browseText: null,
  };

  handleItemClick = (id, data) => {
    const { onDepartmentClick } = this.props;
    try {
      ReactGA.event({
        category: 'BROWSE_UNIVERSITY',
        action: 'Item click',
        label: Object.entries(BROWSE_STATE).find(([_, value]) => {
          return value === this.state.browseState;
        })[0],
      });
    } catch (err) {
      log.error('ga error:', err);
    }
    if (!BROWSE_END_STATE[this.state.browseState]) {
      this.setState(currentState => ({
        browseHistory: [
          ...currentState.browseHistory,
          {
            browseState: currentState.browseState,
            browseValue: currentState.browseValue,
            browseText: currentState.browseText,
          },
        ],
        ...getNextState(currentState.browseState, currentState.browseValue, id, data),
      }));
    }
    if (BROWSE_END_STATE[this.state.browseState] && onDepartmentClick) {
      onDepartmentClick(id);
    }
  };

  handleHistoryClick = popTime => {
    if (popTime >= 0) return;

    const { browseHistory } = this.state;
    const newBrowseHistory = [...browseHistory];
    let newBrowseParams = {};
    for (let count = popTime; count < 0; count++) {
      newBrowseParams = newBrowseHistory.pop();
    }
    this.setState({ browseHistory: newBrowseHistory, ...newBrowseParams });
  };

  handleBackClick = () => {
    try {
      ReactGA.event({
        category: 'BROWSE_UNIVERSITY',
        action: 'Back click',
      });
    } catch (err) {
      log.error('ga error:', err);
    }
    this.handleHistoryClick(-1);
  };

  render() {
    const { showClose, onClose, mockExam, hideHeart, roundCode, hideRounds } = this.props;
    const { browseState, browseValue, browseText, browseHistory } = this.state;
    return (
      <NoTopWrapper>
        <Box m={[0, 3]}>
          <Flex flexDirection="column">
            <NavBar
              enableBack={browseState !== BROWSE_STATE.BROWSE_UNIVERSITY}
              onBackClick={this.handleBackClick}
              showClose={showClose}
              onClose={onClose}
            />
            <NavHeader title={BROWSE_STATE_TEXT[browseState]} {...getStepsIndex(browseState)} />
          </Flex>
        </Box>
        <Box mx={[0, 3]}>
          {browseState === BROWSE_STATE.BROWSE_UNIVERSITY && (
            <UniversityList
              onClick={this.handleItemClick}
              renderHeader={renderHeader(
                generateSteps([...browseHistory, { browseState, browseValue, browseText }]),
                'มหาวิทยาลัย',
              )}
            />
          )}
          {browseState === BROWSE_STATE.BROWSE_FACULTY && (
            <FacultyList
              universityId={browseValue}
              onClick={this.handleItemClick}
              renderHeader={renderHeader(
                generateSteps([...browseHistory, { browseState, browseValue, browseText }]),
                'คณะ',
              )}
            />
          )}
        </Box>
      </NoTopWrapper>
    );
  }
}
